module.exports = __webpack_public_path__ + "static/media/Bank_Markazi.23d6a503.svg";